export const getBasePath = (): string => {
  const pathParts = window.location.pathname.split('/').filter(Boolean)
  const pageIdx = pathParts.indexOf('page')
  const baseParts = pageIdx === -1 ? pathParts : pathParts.slice(0, pageIdx)
  return `/${baseParts.join('/')}`
}

export const getCurrentPage = (): number => {
  return Number(document.querySelector('[data-page-number]')?.getAttribute('data-page-number') ?? 1)
}

export const inputPaginationMechanism = (): void => {
  const input = document.querySelector<HTMLInputElement>('#blogPageNumber')
  if (!input) return

  const currentPage = getCurrentPage()
  const minPage = Number(input.getAttribute('min') ?? 1)
  const maxPage = Number(input.getAttribute('max') ?? currentPage)
  const basePath = getBasePath()

  input.addEventListener('focus', () => {
    input.value = ''
  })
  input.addEventListener('blur', () => {
    if (!input.value || input.value === '0') input.value = String(currentPage)
  })

  input.addEventListener('keydown', (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) e.preventDefault()

    if (e.key === 'Enter') {
      const target = Number(input.value)
      if (Number.isNaN(target) || target < minPage || target > maxPage) {
        input.value = String(currentPage)
        return
      }

      const nextUrl = target <= 1 ? `${basePath}/` : `${basePath}/page/${target}/`

      window.location.href = nextUrl
    }
  })
}
